import React from 'react';
import 'twin.macro';
import { StatsCards } from '@teetsh/app/src/containers/RegistreAppel/Stats/StatsCards';
import { useAppelsStats } from '@teetsh/app/src/queries/appels/useAppelsStats';
import SchoolyearButtonLink from 'components/Buttons/SchoolyearButtonLink';
import { EmptyModule } from 'components/EmptyModule';
import { useTranslation } from 'react-i18next';
import { RocketLaunchIcon } from '@heroicons/react/24/outline';
import { format } from 'utils/time/format';
import { isoDatePatternWithSlashes } from 'utils/time/datePatterns';
import isWithinInterval from 'utils/time/isWithinInterval';
import { getMutualWorkingDays } from 'containers/utils';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';
import { getDay } from 'date-fns';
import { getNextDayBasedOnWorkingDays } from 'utils/time';

interface Props {
  from: Date;
  to: Date;
  eleveId?: string;
}

export function StatsCardsWithData(props: Props) {
  const { from, to, eleveId } = props;
  const { data, isLoading } = useAppelsStats({ from, to, eleveId });
  const { t } = useTranslation(['registreAppel']);
  const classrooms = useClassrooms();
  const workingDays = getMutualWorkingDays(classrooms);
  if (isLoading) {
    return (
      <div tw="grid grid-cols-3 gap-4">
        {[0, 1, 2, 3, 4, 5].map(x => (
          <div key={x} className="tsh-skeleton" tw="h-28 rounded-xl">
            <span tw="invisible">A</span>
          </div>
        ))}
      </div>
    );
  }

  let dateToGoTo = new Date();
  if (!workingDays.map(w => (w + 1) % 7).includes(getDay(dateToGoTo))) {
    dateToGoTo = getNextDayBasedOnWorkingDays(dateToGoTo, workingDays);
  }
  if (data?.totalAppels === 0) {
    const dateToFaireLappel = isWithinInterval(dateToGoTo, {
      start: from,
      end: to,
    })
      ? new Date()
      : from;
    return (
      <div tw="flex justify-center mt-12">
        <EmptyModule
          cta={
            <SchoolyearButtonLink
              large
              to={`registre-appel/appels/${format(
                dateToFaireLappel,
                'fr-FR',
                isoDatePatternWithSlashes,
              )}`}
              intent="primary"
              rightIcon={RocketLaunchIcon}
            >
              {t('registreAppel:faireLappel')}
            </SchoolyearButtonLink>
          }
          title={t('registreAppel:noAppelsForThisRange')}
        />
      </div>
    );
  }
  return <StatsCards data={data} />;
}
